<template>
  <div>
      <el-card class="searchingBox" :style="searchingCard ? {'display': 'none'} : {}">
          <div v-for="o in search_data" :key="o" class="text item" @click="pasteSearchingInfo($event)">
              {{ o }}
          </div>
      </el-card>
      <div id="message-send-box-wrapper1" :style="focus ? {'backgroundColor': 'white'} : {}" @drop="dropHandler">
          <div class="send-header-bar">
              <el-popover placement="top" :visible-arrow=false width="400" trigger="click" popper-class='drawer'>
                  <div class="emojis">
                      <div v-for="(item,index) in emojiName" class="emoji" @click="chooseEmoji(item)" :key="index">
                          <img :src="emojiUrl + emojiMap[item]" />
                      </div>
                  </div>
                  <i slot="reference" class="iconfont iconbiaoqing1 iconsize" title="发表情"></i>
              </el-popover>
              <i class="iconfont icontupian2 iconsize" title="发图片" @click="handleSendImageClick('img')"></i>
              <i class="iconfont iconshangchuanshipin iconsize" title="发视频" @click="handleSendImageClick('video')"></i>
              <i class="iconfont iconshangchuanwenjian iconsize" title="发文件" @click="handleSendImageClick('file')"></i>
              <i class="iconfont icondingwei iconsize" style="font-size:18px !important" title="发位置" @click="handleSendLocationClick"></i>
          </div>
          <el-input ref="text-input" type="textarea" resize="none" class="text-input" v-model="messageContent" placeholder="请输入内容..." @focus="onTextareaFocus" @blur="onTextareaBlur" @keydown.enter.native.prevent="handleLine" @input.native="keyUp"></el-input>
          <div class="send-btn" @click="handleEnter" :style="{'background':'#'+color}">发送</div>
          <input type="file" id="imagePicker" ref="imagePicker" @change="sendImage" style="display:none" accept="image/*" />
          <input type="file" id="videoPicker" ref="videoPicker" @change="sendVideo($event)" style="display:none" accept="video/*" />
          <input type="file" id="filePicker" ref="filePicker" @change="sendFile($event)" style="display:none" accept=".pdf,.txt,.xlsx,.xls,.doc,.docx,.pptx,.html,.js,.json,.csv" />
      </div>
  </div>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
import { mapState } from "vuex";
import { Input } from "element-ui";
import { emojiMap, emojiName, emojiUrl } from "@/utils/emojiMap";
import sessionAPI from "@/api/session";
import xss from 'xss'
export default {
  name: "message-send-box",
  props: ["scrollMessageListToButtom"],
  components: {
      ElInput: Input,
  },
  data() {
      return {
          colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
          messageContent: "",
          isSendCustomMessage: false,
          sendCustomDialogVisible: false,
          surveyDialogVisible: false,
          search_data: [],
          form: {
              data: "",
              description: "",
              extension: "",
          },
          rate: 5, // 评分
          suggestion: "", // 建议
          file: "",
          emojiMap: emojiMap,
          emojiName: emojiName,
          emojiUrl: emojiUrl,
          showAtGroupMember: false,
          atUserID: "",
          focus: false,
          searchingCard: true,
          inputCursorStart: 0,
          inputCursorEnd: 0,
          timer: null,
          searchingTimer: null,
          againTyping: false,
          network: true,
      };
  },

  computed: {
      ...mapState({
          memberList: (state) => state.group.currentMemberList,
          userID: (state) => state.user.userID,
          toAccount: (state) => state.conversation.toAccount,
          currentConversationType: (state) =>
              state.conversation.currentConversationType,
          sign: (state) => state.conversation.sign,
          APPID: (state) => state.conversation.APPID,
          platform: (state) => state.conversation.platform,
          isNeedAssignCustomer: (state) =>
              state.conversation.isNeedAssignCustomer,
          color: (state) => state.user.color,
          enterid: (state) => state.user.enterid,
          zhujianAppId: (state) => state.user.zhujianAppId,
          nickname: (state) => state.user.nickname,
          headimgurl: (state) => state.user.headimgurl,
          anonymity: (state) => state.user.anonymity,
      }),
  },
  mounted() {
      // this.$refs['text-input'].addEventListener('paste', this.handlePaste)
      this.$bus.$on("reEditMessage", this.reEditMessage);
      this.$bus.$on("selectLocation", this.sendLocation);
      this.$bus.$on("sendGoodsLink", this.sendGoodsLink);
      this.$bus.$on("hideKeyboard", this.hideKeyboard);
      this.$bus.$on("sendEvaluateMsg", this.autoSend);
      window.addEventListener("offline", this.updateOnlineStatus);
      window.addEventListener("online", this.updateOnlineStatus);
  },
  watch: {
      userID: function () {
          this.assignCustomer();
      },
  },
  methods: {
      updateOnlineStatus(e) {
          const { type } = e;
          this.network = type === "online";
      },
      keyUp() {
          clearTimeout(this.searchingTimer);
          this.searchingTimer = setTimeout(() => {
              // 获取联想返回值
              let param = {
                  text: this.messageContent,
              };
              sessionAPI
                  .getRelatedInput(param)
                  .then((res) => {
                      if (res) {
                          if (this.messageContent) {
                              this.search_data = res;
                              this.searchingCard = false;
                          }
                      } else {
                          this.searchingCard = true;
                      }
                  })
                  .catch(() => {
                      this.searchingCard = true;
                      return;
                  });
          }, 500);

          if (!this.againTyping) {
              this.sendIMMessage("", "Typing");
              this.againTyping = true;
          }
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
              this.sendIMMessage("", "CancelTyping");
          }, 1000 * 15);
      },
      pasteSearchingInfo(ev) {
          this.searchingCard = true;
          let target = ev.target;
          this.messageContent = target.innerText;
          this.sendTextMessage();
      },
      autoSend(payload) {
          this.searchingCard = true;
          this.messageContent = JSON.parse(payload).value;
          this.sendTextMessage(JSON.parse(payload).se_id);
      },
      reEditMessage(payload) {
          this.messageContent = payload;
      },

      handleUp() {
          const index = this.memberList.findIndex(
              (member) => member.userID === this.atUserID
          );
          if (index - 1 < 0) {
              return;
          }
          this.atUserID = this.memberList[index - 1].userID;
      },

      handleDown() {
          const index = this.memberList.findIndex(
              (member) => member.userID === this.atUserID
          );
          if (index + 1 >= this.memberList.length) {
              return;
          }
          this.atUserID = this.memberList[index + 1].userID;
      },

      handleEnter() {
          this.focus = false;
          this.searchingCard = true;
          this.sendTextMessage();
      },

      handleLine(e) {
          if (e.ctrlKey && e.keyCode == 13) {
              this.messageContent += "\n";
          } else {
              this.handleEnter();
          }
      },

      handlePaste(e) {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          let clipboardData = e.clipboardData;
          let file;
          if (
              clipboardData &&
              clipboardData.files &&
              clipboardData.files.length > 0
          ) {
              file = clipboardData.files[0];
          }

          if (typeof file === "undefined") {
              return;
          }
          // 1. 创建消息实例，接口返回的实例可以上屏
          let message = this.tim.createImageMessage({
              to: this.toAccount,
              conversationType: this.currentConversationType,
              payload: {
                  file: file,
              },
              onProgress: (percent) => {
                  this.$set(message, "progress", percent); // 手动给message 实例加个响应式属性: progress
              },
          });
          this.$store.commit("pushCurrentMessageList", message);

          // 2. 发送消息
          let promise = this.tim.sendMessage(message);
          promise.catch((error) => {
              this.$store.commit("showMessage", {
                  type: "error",
                  message: error.message,
              });
          });
      },

      dropHandler(e) {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          e.preventDefault();
          let file = e.currentTarget.files[0];
          let fileType = file.name.split(".")[1];
          if (
              !"pdf|txt|xlsx|xls|doc|docx|pptx|html|js|json|csv".includes(
                  fileType
              )
          ) {
              this.$store.commit("showMessage", {
                  message: "文件格式不支持",
                  type: "info",
              });
              return;
          }
          let message = {};
          let that = this;
          message = this.tim.createFileMessage({
              to: that.toAccount,
              conversationType: that.currentConversationType,
              payload: {
                  file: document.getElementById("filePicker"),
              },
              onProgress: (percent) => {
                  that.$set(message, "progress", percent); // 手动给message 实例加个响应式属性: progress
              },
          });
          // this.$store.commit('pushCurrentMessageList', message)
          this.tim
              .sendMessage(message)
              .then(() => {
                  this.$refs.filePicker.value = null;
              })
              .catch((imError) => {
                  this.$store.commit("showMessage", {
                      message: imError.message,
                      type: "error",
                  });
              });
      },

      handleXss(content) {
          // 设置HTML过滤器的白名单
        const options = {
          whiteList: {
            p: ['class', 'style'],
            em: ['class', 'style'],
            strong: ['class', 'style'],
            br: ['class', 'style'],
            u: ['class', 'style'],
            s: ['class', 'style'],
            blockquote: ['class', 'style'],
            li: ['class', 'style'],
            ol: ['class', 'style'],
            ul: ['class', 'style'],
            h1: ['class', 'style'],
            h2: ['class', 'style'],
            h3: ['class', 'style'],
            h4: ['class', 'style'],
            h5: ['class', 'style'],
            h6: ['class', 'style'],
            span: ['class', 'style'],
            div: ['class', 'style'],
            img: ['src', 'class', 'style', 'width'],
          },
        };
        // 自定义规则
        const myxss = new xss.FilterXSS(options);
        // 直接调用 myxss.process() 即可
        content= myxss.process(content);
        return content;
      },


      sendTextMessage(se_id) {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          if (
              this.messageContent === "" ||
              this.messageContent.trim().length === 0
          ) {
              this.messageContent = "";
              this.$store.commit("showMessage", {
                  message: "不能发送空消息哦！",
                  type: "info",
              });
              return;
          }
          this.messageContent = this.handleXss(this.messageContent)

          this.searchingCard = true;
          let localMessage = this.pushLocalMessage(
              this.messageContent,
              this.TYPES.MSG_TYPE.TEXT
          );
          this.sendIMMessage(
              this.messageContent,
              this.TYPES.MSG_TYPE.TEXT,
              se_id
          )
              .then((res) => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_SUCCESS;
                  localMessage.ID = res.data.message.ID;
                  localMessage.conversationID =
                      res.data.message.conversationID;
                  localMessage.conversationType =
                      res.data.message.conversationType;
                  let payload_data = res.data.message.payload.send_from;
                  localMessage.isReaded =
                      res.data.message.conversationType == "GROUP" ||
                      payload_data == 5 ||
                      payload_data == 4;
              })
              .catch(() => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
              });
          this.messageContent = "";
      },

      chooseEmoji(item) {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          let cursorStart = this.inputCursorStart; // input 第0个字符到选中的字符
          let cursorEnd = this.inputCursorEnd; // 选中的字符到最后的字符
          if (cursorStart === undefined || cursorEnd === undefined) return;
          let txt = this.messageContent;
          // 将表情添加到选中的光标位置
          let result =
              txt.substring(0, cursorStart) + item + txt.substring(cursorEnd);
          this.messageContent = result; // 赋值给input的value
          this.inputCursorStart += item.length;
          this.inputCursorEnd += item.length;
      },

      handleSendImageClick(type) {
          console.log("network = " + this.network);
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          if (type == "img") {
              this.$refs.imagePicker.click();
          } else if (type == "file") {
              this.$refs.filePicker.click();
          } else {
              this.$refs.videoPicker.click();
          }
      },

      handleShowEmojis() {
          this.focus = false;
          this.$refs["text-input"].blur();
      },

      handleSendLocationClick() {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          this.$bus.$emit("showLocationPicker");
      },

      sendFile(event) {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          let suffix = "";
          let file_file = event.target.files[0];
          let nameSpot = file_file.name;
          let flieArr = nameSpot.split(".");
          suffix = flieArr[flieArr.length - 1];
          if (
              !"pdf|txt|xlsx|xls|doc|docx|pptx|html|js|json".includes(suffix)
          ) {
              this.$refs.filePicker.value = null;
              this.$store.commit("showMessage", {
                  message: "文件格式不支持！",
                  type: "info",
              });
              return;
          }

          if (file_file.size > 10 * 1024 * 1024) {
              this.$refs.videoPicker.value = null;
              this.$store.commit("showMessage", {
                  message: "文件最大支持10M！",
                  type: "info",
              });
              return;
          }
          //获取文件预览
          let localMessage = this.pushLocalMessage(
              file_file,
              this.TYPES.MSG_TYPE.FILE
          );
          localMessage.content = file_file;
          //文件上传
          let formData = new FormData();
          formData.append("file", file_file);
          sessionAPI
              .uploadFile(formData, (progress) => {
                  //获取文件上传进度
                  this.$set(
                      localMessage,
                      "progress",
                      Math.round(progress.loaded / progress.total)
                  );
              })
              .then((res) => {
                  ///通过TIM发送图片信息
                  this.searchingCard = true;
                  if(res.attachment){
                    const serviceImgPath = res.attachment;
                    localMessage.content = res;
                    // this.$set(localMessage, "content", serviceImgPath);
                    this.sendIMMessage(JSON.stringify(res), this.TYPES.MSG_TYPE.FILE)
                    .then((res) => {
                        localMessage.state =
                            this.TYPES.MSG_STATE.SENT_SUCCESS;
                        localMessage.ID = res.data.message.ID;
                        localMessage.conversationID =
                            res.data.message.conversationID;
                        localMessage.conversationType =
                            res.data.message.conversationType;
                        let payload_data =
                            res.data.message.payload.send_from;
                        localMessage.isReaded =
                            res.data.message.conversationType == "GROUP" ||
                            payload_data == 5 ||
                            payload_data == 4;
                        // eslint-disable-next-line no-unused-vars
                    })
                    .catch((sendError) => {
                        localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
                    });
                  }else{
                    this.$store.commit("showMessage", {
                      message: res.msg,
                      type: "info",
                    });
                    return;
                  }
                  // eslint-disable-next-line no-unused-vars
              })
              .catch((uploadError) => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
              });
          this.$refs.filePicker.value = null;
      },

      sendVideo(event) {
          if (!this.network) {
              this.$store.commit("showMessage", {
                  message: "当前网络已断开",
                  type: "info",
              });
              return;
          }
          let file_file = event.target.files[0];
          if (file_file.size > 10 * 1024 * 1024) {
              this.$refs.videoPicker.value = null;
              this.$store.commit("showMessage", {
                  message: "文件最大支持10M！",
                  type: "info",
              });
              return;
          }
          //获取视频预览
          const fileReader = new FileReader();
          const aBob = new Blob([file_file], { type: "video/*" });
          fileReader.addEventListener("load", () => {
              localMessage.content = fileReader.result;
          });
          fileReader.readAsDataURL(aBob);
          //文件上传
          let localMessage = this.pushLocalMessage(
              null,
              this.TYPES.MSG_TYPE.VIDEO
          );
          let formData = new FormData();
          formData.append("file", file_file);
          sessionAPI
              .uploadFile(formData, (progress) => {
                  //获取图片上传进度
                  this.$set(
                      localMessage,
                      "progress",
                      Math.round(progress.loaded / progress.total)
                  );
              })
              .then((res) => {
                  //通过TIM发送图片信息
                  this.searchingCard = true;
                  if(res.attachment){
                    const serviceImgPath = res.attachment;
                    localMessage.content = serviceImgPath;
                    this.$set(localMessage, "content", serviceImgPath);
                    this.sendIMMessage(
                        serviceImgPath,
                        this.TYPES.MSG_TYPE.VIDEO
                    )
                    .then((res) => {
                        localMessage.state =
                            this.TYPES.MSG_STATE.SENT_SUCCESS;
                        localMessage.ID = res.data.message.ID;
                        localMessage.conversationID =
                            res.data.message.conversationID;
                        localMessage.conversationType =
                            res.data.message.conversationType;
                        let payload_data =
                            res.data.message.payload.send_from;
                        localMessage.isReaded =
                            res.data.message.conversationType == "GROUP" ||
                            payload_data == 5 ||
                            payload_data == 4;
                        // eslint-disable-next-line no-unused-vars
                    })
                    .catch((sendError) => {
                        localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
                    });
                  }else{
                    this.$store.commit("showMessage", {
                      message: res.msg,
                      type: "info",
                    });
                    return;
                  }
                  
                  // eslint-disable-next-line no-unused-vars
              })
              .catch((uploadError) => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
              });
          this.$refs.videoPicker.value = null;
      },

      sendImage(event) {
          let file = event.target.files[0];
          if (file.size > 10 * 1024 * 1024) {
              this.$refs.imagePicker.value = null;
              this.$store.commit("showMessage", {
                  message: "文件最大支持10M！",
                  type: "info",
              });
              return;
          }
          //获取图片预览
          const fileReader = new FileReader();
          fileReader.addEventListener("load", () => {
              localMessage.content = fileReader.result;
          });
          fileReader.readAsDataURL(file);
          let localMessage = this.pushLocalMessage(
              null,
              this.TYPES.MSG_TYPE.IMAGE
          );
          //图片上传
          let formData = new FormData();
          formData.append("file", file);
          sessionAPI
              .uploadFile(formData, (progress) => {
                  //获取图片上传进度
                  this.$set(
                      localMessage,
                      "progress",
                      Math.round(progress.loaded / progress.total)
                  );
              })
              .then((res) => {
                  //通过TIM发送图片信息
                  this.searchingCard = true;
                  if(res.attachment){
                    const serviceImgPath = res.attachment;
                    this.sendIMMessage(
                        serviceImgPath,
                        this.TYPES.MSG_TYPE.IMAGE
                    )
                    .then((res) => {
                        localMessage.state =
                            this.TYPES.MSG_STATE.SENT_SUCCESS;
                        localMessage.ID = res.data.message.ID;
                        localMessage.conversationID =
                            res.data.message.conversationID;
                        localMessage.conversationType =
                            res.data.message.conversationType;
                        let payload_data =
                            res.data.message.payload.send_from;
                        localMessage.isReaded =
                            res.data.message.conversationType == "GROUP" ||
                            payload_data == 5 ||
                            payload_data == 4;
                        // eslint-disable-next-line no-unused-vars
                    })
                    .catch(() => {
                        localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
                    });
                  }else{
                    this.$store.commit("showMessage", {
                      message: res.msg,
                      type: "info",
                    });
                    return;
                  }
                  
                  // eslint-disable-next-line no-unused-vars
              })
              .catch(() => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
              });
          this.$refs.imagePicker.value = null;
      },

      sendLocation(location) {
          let locationContent = JSON.stringify({
              name: location.poiname,
              address: location.poiaddress,
              latitude: location.latlng.lat,
              longitude: location.latlng.lng,
          });
          this.searchingCard = true;
          let localMessage = this.pushLocalMessage(
              locationContent,
              this.TYPES.MSG_TYPE.GEO
          );
          this.sendIMMessage(locationContent, this.TYPES.MSG_TYPE.GEO)
              .then((res) => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_SUCCESS;
                  localMessage.ID = res.data.message.ID;
                  localMessage.conversationID =
                      res.data.message.conversationID;
                  localMessage.conversationType =
                      res.data.message.conversationType;
                  let payload_data = res.data.message.payload.send_from;
                  localMessage.isReaded =
                      res.data.message.conversationType == "GROUP" ||
                      payload_data == 5 ||
                      payload_data == 4;
              })
              .catch(() => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
              });
      },

      sendGoodsLink(item) {
          let content = JSON.stringify({
              name: item.name,
              img: item.img,
              description: item.description,
              price: item.price,
          });
          this.searchingCard = true;
          let localMessage = this.pushLocalMessage(
              content,
              this.TYPES.MSG_TYPE.GOODS
          );
          this.sendIMMessage(content, this.TYPES.MSG_TYPE.GOODS)
              .then((res) => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_SUCCESS;
                  localMessage.ID = res.data.message.ID;
                  localMessage.conversationID =
                      res.data.message.conversationID;
                  localMessage.conversationType =
                      res.data.message.conversationType;
                  let payload_data = res.data.message.payload.send_from;
                  localMessage.isReaded =
                      res.data.message.conversationType == "GROUP" ||
                      payload_data == 5 ||
                      payload_data == 4;
              })
              .catch(() => {
                  localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL;
              });
      },

      onTextareaBlur(event) {
          this.inputCursorStart = event.srcElement.selectionStart;
          this.inputCursorEnd = event.srcElement.selectionEnd;
          document.activeElement.scrollIntoViewIfNeeded(true);
          this.focus = false;
          this.sendIMMessage("", "CancelTyping");
      },

      // eslint-disable-next-line no-unused-vars
      onTextareaFocus(event) {
          this.focus = true;
          document.documentElement.scrollTop = 10000;
      },

      hideKeyboard() {
          if (this.focus) {
              this.focus = false;
              this.$refs["text-input"].blur();
          }
      },

      /**
       * 添加本地消息记录
       * @param {string} content 消息内容
       * @param {string} msgType 消息类型
       */
      pushLocalMessage(content, msgType) {
          let createTime = new Date().getTime();
          let localMessage = {
              nickname: this.nickname,
              sendFrom: this.TYPES.MSG_FROM.USER,
              state: this.TYPES.MSG_STATE.SENDING,
              headimgurl: this.headimgurl,
              createTime: createTime,
              content: content,
              type: msgType,
              isReaded: false,
          };
          this.$store.dispatch("formatSendTime", localMessage);
          this.$store.commit("pushCurrentMessageList", localMessage);
          this.$bus.$emit("scroll-bottom");
          return localMessage;
      },

      async assignCustomer() {
          if (this.isNeedAssignCustomer) {
              let params = {
                  enterid: this.enterid,
                  sign: this.sign,
                  appid: this.APPID,
                  fromAccount: this.userID,
              };
              if (this.anonymity) {
                  params["anonymity"] = true;
              } else if (this.$route.query.k) {
                  params["anonymity"] = true;
              }
              let toAccount = await sessionAPI.getCustomerAccount(params);
              this.$store.commit({
                  type: "updateConversation",
                  toAccount: toAccount.id,
                  convType: toAccount.type,
              });
              this.$store.commit({
                  type: "setNeedAssignCustomer",
                  isNeedAssignCustomer: false,
              });
          }
      },

      /**
       * 通过TIM发送信息
       * @param {string} content 消息内容
       * @param {string} msgType 消息类型
       */
      async sendIMMessage(
          content,
          msgType,
          se_id = sessionStorage.getItem("currentSessionID")
      ) {
          console.log("se_id2" + se_id);
          await this.assignCustomer();
          return new Promise((resolve, reject) => {
              const to = this.toAccount;
              const conversationType = this.currentConversationType;
              // 创建TIM消息
              let message = this.tim.createCustomMessage({
                  to: to,
                  conversationType: conversationType,
                  payload: {
                      data: JSON.stringify({
                          sign: this.sign,
                          appid: this.APPID,
                          platform: this.platform,
                          nickname: this.nickname,
                          headimgurl: this.headimgurl,
                          content: content,
                          contents: content,
                          bizmsgmenuid: se_id,
                          session_id: se_id,
                          send_from: 1,
                      }),
                      extension: msgType,
                  },
              });
              if (msgType == "CancelTyping") {
                  this.againTyping = false;
              } else if (msgType != "Typing") {
                  clearTimeout(this.timer);
                  this.sendIMMessage("", "CancelTyping");
              }
              console.log('', message);
              this.tim
                  .sendMessage(message)
                  .then((res) => {
                      console.log("Log: TIM发送信息成功 -> res", res);
                      resolve(res);
                  })
                  .catch((error) => {
                      console.log("Log: TIM发送信息失败 -> error", error);
                      reject(error);
                  });
          });
      },
  },
  beforeDestroy() {
      window.removeEventListener("online", this.updateOnlineStatus);
      window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>

<style lang="stylus">
.searchingBox {
  position: absolute;
  width: 100%;
  top: -94px;
  z-index: 999999;
  background-color: #ffffff;
  height: 92px;
  overflow: auto;
}

.text {
  font-size: 12px;
  word-break: break-all;
}

.item {
  padding: 4px 0;
}

.el-card__body {
  padding: 12px 20px;
}

#message-send-box-wrapper1 {
  // box-sizing: border-box;
  overflow: hidden;
  height: 100%;

  .iconsize {
      font-size: 17px !important;
  }

  .emojis {
      height: 160px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      overflow-y: scroll;
  }

  .send-header-bar {
      box-sizing: border-box;
      padding: 5px 20px;
  }

  .send-header-bar i {
      cursor: pointer;
      color: gray;
      margin-right: 12px;
  }

  .send-header-bar i:hover {
      color: $black;
  }

  .text-input {
      font-size: 12px; /* no */
      border: none;
      outline: none;
      background-color: transparent;
      height: 70px;
  }

  .el-textarea__inner {
      padding: 5px 20px !important;
      border: none !important;
      height: 70px;
  }

  .send-btn {
      color: #fff;
      background: #000;
      border-radius: 5px;
      font-size: 14px;
      width: 78px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      position: absolute;
      bottom: 20px;
      right: 24px;
      cursor: pointer;
  }

  .block {
      padding: 10px 0;
      display: flex;
      align-items: center;
  }

  .quick-ask {
      padding: 15px 0;
      width: 100%;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;

      div {
          display: inline-block;
          background: #FFFFFF;
          border: 1px solid #E6E6E6;
          border-radius: 14px;
          font-size: 12px;
          color: #333333;
          padding: 6px 10px;
          margin-right: 10px;
      }
  }
}

.drawer {
  padding-top: 20px; /* no */
  max-height: 160px;
  overflow: auto;
  // width 320px !important
}

.drawer::after {
  border-color: transparent #210ec5 transparent transparent;
  border-width: 10px;
  border-style: solid;
  width: 10px;
  height: 10px;
  top: 10px;
  position: absolute;
  z-index: 18;
}

@media screen and (max-width: 924px) {
  .drawer {
      left: 10px !important;
  }
}

@media screen and (min-width: 925px) {
  .drawer {
      left: 28.5% !important;
  }
}

.el-popper[x-placement^=top] .popper__arrow::after {
  border-top-color: red;
}

.emojis {
  display: flex;
  flex-wrap: wrap;
}

.emoji {
  height: 40px;
  width: 40px;
  box-sizing: border-box;
}

.emoji img {
  width: 26px;
  height: 26px;
}
</style>
